import AxiosService from './axios';
import ProtectedRouteComponent from '../components/ProtectedRoute';

export const getUserId = () => AxiosService.getIdToken()
export const closeSession = () => AxiosService.closeSession()

export const ProtectedRoute = ProtectedRouteComponent;
